import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { LogsContent } from "@/features/dashboard/logs/components/LogsContent";

export const Route = createFileRoute("/_private/dashboard/_base/logs/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Logs" from="/dashboard/logs/$id">
      <LogsContent />
    </BaseEditCreateModal>
  );
}
